import { Component, OnInit } from "@angular/core";
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { data } from "src/app/audit-trail/application/data";
import { AuditTrailService } from "src/app/audit-trail/audit-trail.service";
import { LotteryFormResponse } from "src/app/model/LotteryFormResponse";
import { ExportImportService } from "src/app/services/export-import.service";
import { PublishLettersService } from "src/app/services/publish-letters.service";
import { ReportService } from "src/app/services/report.service";

@Component({
  selector: "app-secure-profile-reset",
  templateUrl: "./profile-reset.component.html",
  styleUrls: ["./profile-reset.component.scss"],
})
export class ProfileResetComponent implements OnInit {
  [x: string]: any;
  form: FormGroup = new FormGroup({});
  isLoading = false;
  lotteryList: {[key: number]: string};
  isSubmitDisabled: boolean = false;
  downloadedBatches: string[] = [];
  panNumber: any;
 

  
  constructor(
    private router: Router,
    private exportImportService: ExportImportService,
    private reportService:ReportService,
    private publishLetterService: PublishLettersService,
    private auditTrailService: AuditTrailService
    , private _snackBar: MatSnackBar
  ) {}

  ngOnInit(): void {
    this.loadData();
  }

  loadData() {

    this.reportService.initQueryExecutorForm().subscribe((data)=>{
      this.boards= data.boards;
      console.log(data);
    })

    this.publishLetterService
    .publishDocumentsInitForm()
    .subscribe((data: any) => {
       this.isLoading = false;
        this.lotteryList = data.lotteryList;
    }, error => {
      this.isLoading = false;
      this.publishLetterService.errorToast(error.errorMessage||error.error.errorMessage);
    });
  
  }

 
  refresh() {
    this.loadData();
  }


  async successToast(msg:any) {
    await this._snackBar.open(
        msg,
        "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "success-toast",
        duration: 3 * 1000,
        }
    );
}

// async mysuccessToast(msg:any) {
//   await this._snackBar.open(
//       msg,
//       "Close", {
//       horizontalPosition: "right",
//       verticalPosition: "top",
//       panelClass: "success-toast",
//       duration: 3 * 1000,
//       }
//   );
// }

// async myErrorToast(msg:any) {
//   await this._snackBar.open(
//       msg,
//       "Close", {
//       horizontalPosition: "right",
//       verticalPosition: "top",
//       panelClass: "error-toast",
//       duration: 3 * 1000,
//       }
//   );
// }

async errorToast(msg:any) {
  await this._snackBar.open(
      msg,
      "Close", {
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass: "error-toast",
      duration: 3 * 1000,
      }
  );
}


resetProfile() {
    console.log(this.panNumber);

    this.auditTrailService.resetProfile({panNumber:this.panNumber})
    .subscribe((data) => {
      // console.log(data,"=========>");
      this.isLoading = false;
      if(data.status === 'SUCCESS') {
        this.successToast(data.successMsg);

        this.panNumber ='';
      }
      else {
        this.errorToast(data.errorMessage); 
        this.panNumber ='';
      }
    }, error => {
      this.isLoading = false;
      this.exportImportService.errorToast(error?.error?.message||error?.errorMessage||error?.error?.errorMessage);
    });
 
}


}